import { combineReducers } from 'redux';

import { InternationalizationState, InternationalizationActionTypes } from './types';
import { languagesReducer } from './languages/reducer';
import { translationsReducer } from './translations/reducer';

export const internationalizationReducer = combineReducers<InternationalizationState, InternationalizationActionTypes>({
    languages: languagesReducer,
    translations: translationsReducer,
});